import { Globe, Info, LogIn, Moon, Sun } from "lucide-react";
import { SignedIn, SignedOut, SignInButton, UserButton } from "@clerk/react-router";
import { Button } from "~/components/ui";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { getNextLanguage, useChangeLanguage } from "@noa/i18n";
import { localLanguageStorage } from "~/utils/language-storage";
import { useSetThemeMode, useThemeMode } from "~/store/ui-preferences.store";

interface AppUserProfileProps {
  onAboutClick: () => void;
}

export const AppUserProfile: FunctionComponent<AppUserProfileProps> = ({ onAboutClick }) => {
  const { t, i18n } = useTranslation();
  const themeMode = useThemeMode();
  const setThemeMode = useSetThemeMode();
  const changeLanguage = useChangeLanguage(localLanguageStorage);

  const isDark = themeMode === "dark";
  const nextLanguage = getNextLanguage(i18n.language);

  return (
    <>
      <SignedOut>
        <SignInButton>
          <Button variant="primary" icon={<LogIn size={14} />}>
            Se connecter
          </Button>
        </SignInButton>
      </SignedOut>

      <SignedIn>
        <div className="flex h-full items-center">
          <UserButton
            appearance={{
              elements: {
                userButtonTrigger: {
                  backgroundColor: "var(--bg)",
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  border: "1px solid var(--border)",
                },
                userButtonAvatarBox: {
                  backgroundColor: "var(--bg)",
                },
              },
            }}
          >
            <UserButton.MenuItems>
              <UserButton.Action
                label={nextLanguage.selectionLabel}
                labelIcon={
                  <span className="compact-action-marker">
                    <Globe size={14} />
                  </span>
                }
                onClick={() => changeLanguage(nextLanguage.code)}
              />
              <UserButton.Action
                label={isDark ? t("theme:switchToLight") : t("theme:switchToDark")}
                labelIcon={
                  <span className="compact-action-marker">{isDark ? <Sun size={14} /> : <Moon size={14} />}</span>
                }
                onClick={() => setThemeMode(isDark ? "light" : "dark")}
              />
              <UserButton.Action
                label={t("about:shortTitle")}
                labelIcon={
                  <span className="compact-action-marker">
                    <Info size={14} />
                  </span>
                }
                onClick={onAboutClick}
              />
            </UserButton.MenuItems>
          </UserButton>
        </div>
      </SignedIn>
    </>
  );
};
